import React, { useCallback, useContext, useEffect, useState } from 'react';
import { AppContext } from '../../app';
import { Button, Select, Form, Radio, Alert } from 'antd';

import { Upload } from 'antd';
import { UploadOutlined } from '@ant-design/icons';
import texts from '../../../../utils/texts';
import { useSelector } from 'react-redux';
import { showMessageError } from '@Utils/RenderUtils';
const TrSpecificUsers = (props) => {
  const [form] = Form.useForm();
  const { journey, syncCache } = useContext(AppContext);
  const [fileUploadPath, setFileUploadPath] = useState();
  const { attributes } = props.data;
  const attributes_sub_ = attributes.filter((attr) =>
    ['email', 'phone', 'userId'].includes(attr.name)
  );
  const currentStep = journey.steps.find(
    (step) => step.id + '' === props.node.id + ''
  );
  const attr = attributes.find((ev) => ev.id === currentStep.staticAttribute);
  const [selectedValue] = useState(attr && attr.name);
  const [collapseField, setCollapseField] = useState(
    currentStep.collapseField || null
  );
  const journeyFileUpload = useSelector((state) => state.engage.journey.file);
  const fileError = useSelector((state) => state.engage.journey.fileError);
  const loadingFile = useSelector((state) => state.engage.journey.loadingFile);

  const collapseFieldsOptions = useCallback(() => {
    const temp_ = [{ value: null, title: 'Nothing' }];
    attributes?.filter((attr) => {
      if (
        attr.name === 'phone' ||
        attr.name === 'email' ||
        attr.name === 'hashedEmail' ||
        attr.name === 'hashedPhone'
      ) {
        temp_.push({
          title: attr.title,
          value: attr.id,
        });
      }
    });
    return temp_;
  }, [attributes]);

  useEffect(() => {
    if (currentStep.staticFile) {
      setFileUploadPath(currentStep.staticFile);
    }
  }, []);
  const onFinish = (e) => {
    // return
    let currentStep = journey.steps.find(
      (step) => step.id + '' === props.node.id + ''
    );

    // Required: triggerAttr (type selection)
    if (!e.triggerAttr) {
      showMessageError(
        new Error(
          'Please select a type (Email Address, User Identifier, or Phone Number)'
        )
      );
      return;
    }

    const attr = attributes.find((ev) => ev.name === e.triggerAttr);
    if (!attr) {
      showMessageError(new Error('Please select a valid type'));
      return;
    }

    // Required: CSV file upload
    if (!fileUploadPath || fileError) {
      showMessageError(fileError || new Error('Please upload a CSV file'));
      return;
    }

    // Optional: collapseField (Remove duplicate) - no validation needed

    currentStep['staticAttribute'] = attr.id;
    currentStep['collapseField'] = collapseField;
    currentStep['staticFile'] = fileUploadPath;
    delete currentStep.ui?.error;
    syncCache('update-step', currentStep, true);

    props.closeModal();
  };

  const onChangeCollapseField = (value) => {
    setCollapseField(value);
  };

  return (
    <>
      <Form
        form={form}
        onFinish={onFinish}
        layout={'horizontal'}
        className="modal_wrap"
        initialValues={{
          triggerAttr: selectedValue,
        }}
      >
        <div className={'modal-body'}>
          <Alert
            message={`Please ensure that the user IDs in your CSV file are those of existing users only. The journey will NOT get triggered for those users who don’t currently exist in your ${texts.brandName} project. Also, note that the process of triggering journeys through this trigger is not instantaneous and can take a few minutes based on the number of users.`}
            type="info"
          />
          <br />
          <br />
          <Form.Item
            label="Select a type"
            name="triggerAttr"
            rules={[{ required: true, message: 'Please add a type!' }]}
          >
            <Select
              showSearch
              style={{ width: 300 }}
              placeholder="Select a type"
              defaultValue={selectedValue}
              allowClear
              disabled={props.readOnly}
            >
              {attributes_sub_?.map((item) => (
                <Select.Option key={item.id} value={item.name}>
                  {item.title}
                </Select.Option>
              ))}
            </Select>
          </Form.Item>

          <Form.Item label="TRIGGER JOURNEY FOR" name="triggerFor">
            <Radio checked>Users in CSV file</Radio>
          </Form.Item>

          <Form.Item label="LIST OF USERS" name="listUsers">
            {/* <Button onClick={onUploadFile} 
                className={"style-button"} 
                disabled={props.loading}>SELECT FILE</Button> */}
            <Upload
              name="file"
              accept=".csv,.txt,.xls,.xlsx"
              multiple={false}
              maxCount={1}
              onRemove={() => setFileUploadPath(null)}
              onChange={(info) => {
                if (info.file.status === 'done') {
                  setFileUploadPath(info.file.response.path);
                }
              }}
              customRequest={(info) => {
                props.data?.uploadJourneyFileFetch(info.file);
                if (journeyFileUpload) {
                  info.onSuccess(journeyFileUpload);
                }
              }}
              defaultFileList={
                currentStep.staticFile
                  ? [
                      {
                        uid: '1',
                        name: decodeURI(
                          currentStep.staticFile.split('/').pop()
                        ),
                        status: 'done',
                        url: currentStep.staticFile,
                      },
                    ]
                  : undefined
              }
            >
              <Button
                shape="round"
                loading={loadingFile}
                icon={<UploadOutlined />}
                style={{ marginLeft: 20 }}
                ghost
              >
                SELECT FILE
              </Button>
            </Upload>
          </Form.Item>
          <div className={'csv__caption-size'}>
            Maximum file size: 50 MB. File format: CSV file with single user
            attribute on each row. Start entering values from the first
            row.&nbsp;
            <a href="/files/user_ids_sample.csv" download>
              Download sample CSV
            </a>{' '}
            file to see format.
          </div>
          <div>
            <br />
            <p>Remove duplicate with:</p>
            <Select
              disabled={props.readOnly}
              style={{ width: 300 }}
              value={collapseField}
              onChange={onChangeCollapseField}
              showSearch
              placeholder="Select option"
            >
              {collapseFieldsOptions()?.map((option, k) => (
                <Select.Option key={k} value={option.value}>
                  {option.title}
                </Select.Option>
              ))}
            </Select>
          </div>
          {/* <IconFilter className={"icon-sm"} /> */}
        </div>
        <div className={'modal-footer'}>
          <Form.Item>
            <Button
              type="primary"
              shape="round"
              htmlType="submit"
              loading={loadingFile}
              disabled={props.readOnly}
            >
              Save and Return to Journey
            </Button>
          </Form.Item>
        </div>
      </Form>
    </>
  );
};
export default TrSpecificUsers;
